import { render, staticRenderFns } from "./defaultWithoutScroll.vue?vue&type=template&id=0b9bcf77&scoped=true"
import script from "./defaultWithoutScroll.vue?vue&type=script&lang=js"
export * from "./defaultWithoutScroll.vue?vue&type=script&lang=js"
import style0 from "./defaultWithoutScroll.vue?vue&type=style&index=0&id=0b9bcf77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9bcf77",
  null
  
)

export default component.exports